import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ServicePlanReview6MoAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ServicePlanReview6MoAdult' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <input type='checkbox' id='cbAdult' name='cbAdult' className='add-only' value='Adult' /> Adult
                    <br />
                    <input type='checkbox' id='cbChild' name='cbChild' className='add-only' value='Child' /> Child
                    <br />
                    <input type='checkbox' id='cbHistoryTrauma' name='cbHistoryTrauma' className='add-only' value='HistoryTrauma' /> History of Trauma

                </p>

                <p className='w-750'><h3>SERVICE PLAN REVIEW</h3></p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_2_1' name='rb_2' className='add-only' value='1' /> No Change
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_2_2' name='rb_2' className='add-only' value='2' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_2_3' name='rb_2' className='add-only' value='3' /> Regressing
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_2_4' name='rb_2' className='add-only' value='4' /> Resolved
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal # 1</span>
                    <textarea id='txt_3' name='txt_3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>List progress or lack of progress areas that need to be addressed since last review:</span>
                    <textarea id='txt_4a' name='txt_4a' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_21_1' name='rb_21' className='add-only' value='1' /> No Change
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_21_2' name='rb_21' className='add-only' value='2' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_21_3' name='rb_21' className='add-only' value='3' /> Regressing
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_21_4' name='rb_21' className='add-only' value='4' /> Resolved
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal # 2</span>
                    <textarea id='txt_31' name='txt_31' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>List progress or lack of progress areas that need to be addressed since last review:</span>
                    <textarea id='txt_4aa' name='txt_4aa' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_22_1' name='rb_22' className='add-only' value='1' /> No Change
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_22_2' name='rb_22' className='add-only' value='2' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_22_3' name='rb_22' className='add-only' value='3' /> Regressing
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_22_4' name='rb_22' className='add-only' value='4' /> Resolved
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal # 3</span>
                    <textarea id='txt_32' name='txt_32' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>List progress or lack of progress areas that need to be addressed since last review:</span>
                    <textarea id='txt_4ab' name='txt_4ab' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_23_1' name='rb_23' className='add-only' value='1' /> No Change
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_23_2' name='rb_23' className='add-only' value='2' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_23_3' name='rb_23' className='add-only' value='3' /> Regressing
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_23_4' name='rb_23' className='add-only' value='4' /> Resolved
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Goal # 4</span>
                    <textarea id='txt_33' name='txt_33' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>List progress or lack of progress areas that need to be addressed since last review:</span>
                    <textarea id='txt_4ac' name='txt_4ac' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rb_24_1' name='rb_24' className='add-only' value='1' /> No Change
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_24_2' name='rb_24' className='add-only' value='2' /> Improving
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_24_3' name='rb_24' className='add-only' value='3' /> Regressing
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rb_24_4' name='rb_24' className='add-only' value='4' /> Resolved
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>New Problem or Need:</span>
                    <textarea id='txt_14' name='txt_14' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>New Identified Goal:</span>
                    <textarea id='txt_15' name='txt_15' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Objective:</span>
                    <textarea id='txt_16' name='txt_16' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Target Date:</span>
                            <input type='date' id='txt_17' name='txt_17' className='add-only' />
                        </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Responsible Provider:</span>
                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_1' name='cbResponsibleProvider_1' className='add-only' value='ResponsibleProvider_1' />Client;</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_2' name='cbResponsibleProvider_2' className='add-only' value='ResponsibleProvider_2' />Case Manager;</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_3' name='cbResponsibleProvider_3' className='add-only' value='ResponsibleProvider_3' />Psychiatrist</td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_4' name='cbResponsibleProvider_4' className='add-only' value='ResponsibleProvider_4' />Therapist</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_5' name='cbResponsibleProvider_5' className='add-only' value='ResponsibleProvider_5' />Acitivity Specialist</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbResponsibleProvider_6' name='cbResponsibleProvider_6' className='add-only' value='ResponsibleProvider_6' />Other : &nbsp;
                            <input type='text' id='txtResponsibleProvider_6' name='txtResponsibleProvider_6' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>New Problem or Need:</span>
                    <textarea id='txt_18' name='txt_18' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>New Identified Goal:</span>
                    <textarea id='txt_19' name='txt_19' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective:</span>
                    <textarea id='txt_20' name='txt_20' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Target Date:</span>
                            <input type='date' id='txt_21' name='txt_21' className='add-only' />
                        </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Responsible Provider:</span>
                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_11' name='cbResponsibleProvider_11' className='add-only' value='ResponsibleProvider_11' />Client;</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_12' name='cbResponsibleProvider_12' className='add-only' value='ResponsibleProvider_12' />Case Manager;</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_13' name='cbResponsibleProvider_13' className='add-only' value='ResponsibleProvider_13' />Psychiatrist</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_14' name='cbResponsibleProvider_14' className='add-only' value='ResponsibleProvider_14' />Therapist</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResponsibleProvider_15' name='cbResponsibleProvider_15' className='add-only' value='ResponsibleProvider_15' />Acitivity Specialist</td>
                    </tr>


                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbResponsibleProvider_16' name='cbResponsibleProvider_16' className='add-only' value='ResponsibleProvider_16' />Other : &nbsp;
                            <input type='text' id='txtResponsibleProvider_16' name='txtResponsibleProvider_16' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txt_20n' name='txt_20n' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>METHODS</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Type:</span>
                            <input type='checkbox' id='cb_22' name='cb_22' className='add-only' value='1' /> Assessment/Review
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Frequency:</span>
                            <input type='text' id='txt_23' name='txt_23' className='add-only w-280 custom-add-only' />&nbsp; X Annually
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Length of Session:</span>
                            <input type='text' id='txt_24' name='txt_24' className='add-only w-150 custom-add-only' /> &nbsp; Hours &nbsp;
                            <input type='text' id='txt_25' name='txt_25' className='add-only w-150 custom-add-only' /> &nbsp; Minutes
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Service Type:</span>
                            <input type='checkbox' id='txt_26' name='txt_26' className='add-only' value='1' /> Case management/Monitoring
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Frequency:</span>
                            <input type='text' id='txt_27' name='txt_27' className='add-only w-150 custom-add-only' /> &nbsp;
                            X &nbsp;
                            <input type='text' id='txt_27_1' name='txt_27_1' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Length of Session:</span>
                            <input type='text' id='txt_28' name='txt_28' className='add-only w-150 custom-add-only' /> &nbsp; Hours &nbsp;
                            <input type='text' id='txt_28_1' name='txt_28_1' className='add-only w-150 custom-add-only' /> &nbsp; Minutes
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Copy of Service Plan:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_29_1' name='rb_29' className='add-only' value='1' /> Hand Delivered
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_29_2' name='rb_29' className='add-only' value='1' /> Mailed
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_29_3' name='rb_29' className='add-only' value='1' /> Both
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Review Update Date:</span>
                    <input type='text' id='txt_30' name='txt_30' className='add-only' />
                </p>
                <p className='w-750'>
                    This is to certify that the services prescribed and recommended in this service plan are appropriate and medically
                    necessary to meet the recipient's needs, as defined by the Florida Medicaid Program.
                </p>

            </div>
        </form>

    )
}

